import SvgIcon from "../svg-icon";
import './index.css'
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import associateServices from "../../services";
import SvgIconExternal from "../svg-icon-external";
import {useLocation, useNavigate} from "react-router-dom";

const SidebarLanguage = () => {

    const {languages, activeLanguage} = useSelector(state => state.globalReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const location = useLocation();
    const navigate = useNavigate();
    const handleUpdateLanguage = language => {
        store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(language.key))
        if (authenticated)
            associateServices.setLanguage({
                language: language?.key
            }).then(null)

        // Build the new path with the selected language
        const pathSegments = location.pathname.split('/');
        pathSegments[1] = language.key; // Set the new language segment
        const newPath = pathSegments.join('/');

        // Navigate to the new path
        navigate(newPath);

    }

    return (
        <div className="sidebar__lang">
            {
                activeLanguage?.flag &&
                <a
                    className="sidebar__lang-btn"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <SvgIconExternal icon={activeLanguage?.flag}/>
                    <SvgIcon id={'right-down'}/>
                </a>
            }


            <ul className="dropdown-menu sidebar__lang-menu">
                {
                    languages?.map(language => (
                        <li key={language.key}>
                            <a onClick={e => handleUpdateLanguage(language)}>
                                <SvgIconExternal icon={language.flag}/>
                                <span>
                                    {language?.key?.toUpperCase()}
                                </span>
                            </a>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default SidebarLanguage
